import React, { useState } from "react";
import { Card, CardContent, Divider, Tab, Button } from "@mui/material"
import styled from "@emotion/styled"
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ProjectOverview from "./ProjectOverview";
import ProjectCommentTab from "./ProjectCommentTab";
import ProjectTimeTab from "./ProjectTimeTab";
import ActivityLog from "./ActivityLog";
import { openNewComment } from "../redux/slices/ui";
import { Add } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

const FullCard = styled(Card)(({ theme }) => ({
    gridColumn: 'span 3',
}));

const StyledTabList = styled(TabList)(({ theme }) => ({
    borderBottom: 1,
    borderColor: 'divider',
}));

const TabContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        gap: theme.spacing(1),
    },
}));

const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
    padding: theme.spacing(2, 1),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1, 0),
    },
}));

const AddCommentButton = styled(Button)(({ theme }) => ({
    display: 'block',
    marginLeft: 'auto',
}))

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1, 0),
    }
}))

const ProjectContext = () => {
    const dispatch = useDispatch();
    const project = useSelector(state => state.project.currentProject);
    const [currentTab, setCurrentTab] = useState('comments');

    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };

    const handleAddNewComment = () => {
        dispatch(openNewComment());
    };

    return (
        <FullCard>
            <StyledCardContent>
                <ProjectOverview />
                <Divider />
                <TabContext value={currentTab}>
                    <TabContainer>
                        <StyledTabList onChange={handleTabChange}>
                            <Tab label="Comments" value="comments" />
                            <Tab label="Time Records" value="time-records" />
                            <Tab label="Activity" value="recent-activity" />
                        </StyledTabList>
                        {currentTab === 'comments' && project.commentsEnabled && (
                            <AddCommentButton
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={handleAddNewComment}
                                disabled={!project.commentsEnabled || !!project.completedDate || !!project.isDeleted}
                            >
                                <Add fontSize="16px" /> {project.commentsEnabled && !project.completedDate ? "Add Comment" : "Comments Disabled"}
                            </AddCommentButton>
                        )}
                    </TabContainer>
                    <StyledTabPanel value="comments">
                        <ProjectCommentTab />
                    </StyledTabPanel>
                    <StyledTabPanel value="time-records">
                        <ProjectTimeTab />
                    </StyledTabPanel  >
                    <StyledTabPanel value="recent-activity">
                        <ActivityLog objectId={project._id} objectType="project" />
                    </StyledTabPanel>
                </TabContext>
            </StyledCardContent>
        </FullCard >
    );
};

export default ProjectContext